module.exports = __webpack_public_path__ + "img/default_secret@2x.0942646e.png";